export var IdEvent;
(function (IdEvent) {
    IdEvent[IdEvent["PurchasePoints"] = 27] = "PurchasePoints";
    IdEvent[IdEvent["Trader"] = 28] = "Trader";
    IdEvent[IdEvent["FortuneTeller"] = 42] = "FortuneTeller";
})(IdEvent || (IdEvent = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdEvents.ts
// module id = 555
// module chunks = 3